import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container } from 'react-bootstrap';
import SavingsEnrollmentImg from '../../assets/savings-enrollment.svg';
import Button from '../../components/Button';
import DefaultCard from '../../components/DefaultCard';
import GenericCards from '../../components/GenericCards';
import Link from '../../components/Link';
import SavingsEnrollmentStepper from '../widgets/savingsEnrollmentStepper/SavingsEnrollmentStepper';

const SavingsEnrollment = () => {
  const [isStepperVisible, setStepperVisible] = React.useState(false);
  const handleStepperVisible = () => {
    setStepperVisible(true);
  };

  const handleRetirementCompletion = (isVisible: boolean) => {
    setStepperVisible(isVisible);
  };

  return (
    <>
      <Container className="cnd-custom-container my-12 px-lg-9 px-xl-0">
        {!isStepperVisible ? (
          <>
            <section className="d-lg-flex flex-lg-row justify-content-between">
              <Col className="col-12 col-lg-7 d-flex flex-column justify-content-center">
                <h3 className="lh-xs text-sm-20-lg-48">
                  Start saving in your 401(k)
                </h3>
                <span className="text-sub1 lh-xs fw-light">
                  It is never to early to start saving for retirement. Enrolling
                  in the 401(k) plan is quick and easy. Once you enroll, salary
                  deferrals are deducted automatically which makes saving in the
                  plan convenient. By participating sooner rather than later,
                  you get the power of compound interest on your side, which
                  will help build your retirement savings faster.
                </span>
              </Col>
              <Col className="pt-12 pt-lg-0 col-12 col-lg-5 d-lg-flex justify-content-lg-end">
                <img
                  src={SavingsEnrollmentImg}
                  alt="retire-online"
                  className="w-100"
                />
              </Col>
            </section>
            <>
              <section className="d-lg-flex flex-lg-row pt-10">
                <Col className="col-12 col-lg-4">
                  <Container className="pe-lg-3 px-0">
                    <GenericCards
                      variant="transperant"
                      className="d-flex flex-column border p-10 rounded-1"
                    >
                      <h5 className="lh-sm mb-0">Video 1</h5>
                      <span className="fw-bolder text-sub1 lh-xs">
                        Sub-title
                      </span>
                      <span className="fw-light text-sub1 lh-xs">
                        With supporting text below as a natural lead-in to
                        additional content.
                      </span>
                      <span>
                        <Button
                          variant="primary-outline"
                          className="mt-9"
                          rightIcon={light('play')}
                        >
                          Watch
                        </Button>
                      </span>
                    </GenericCards>
                  </Container>
                </Col>
                <Col className="col-12 col-lg-4">
                  <Container className="py-7 py-lg-0 px-0 ps-lg-3">
                    <GenericCards
                      variant="transperant"
                      className="d-flex flex-column border p-10 rounded-1"
                    >
                      <h5 className="lh-sm mb-0">Video 2</h5>
                      <span className="fw-bolder text-sub1 lh-xs">
                        Subtitle
                      </span>
                      <span className="fw-light text-sub1 lh-xs">
                        With supporting text below as a natural lead-in
                        to additional content.
                      </span>
                      <span>
                        <Button
                          variant="primary-outline"
                          className="mt-9"
                          rightIcon={light('play')}
                        >
                          Watch
                        </Button>
                      </span>
                    </GenericCards>
                  </Container>
                </Col>
                <Col className="col-12 col-lg-4">
                  <Container className="ps-lg-7 px-0">
                    <GenericCards
                      variant="transperant"
                      className="d-flex flex-column p-10"
                    >
                      <h5 className="text-nowrap">Helpful Resources</h5>
                      <Link
                        rightIcon={light('chevron-right')}
                        onSelect={(selectedKey) =>
                          console.log(`selected ${selectedKey}`)
                        }
                        eventKey="test"
                        className="pt-5"
                        isAlignAtEnd
                        isBlue
                      >
                        General links to external site
                      </Link>
                      <Link
                        rightIcon={light('chevron-right')}
                        onSelect={(selectedKey) =>
                          console.log(`selected ${selectedKey}`)
                        }
                        eventKey="test"
                        className="pt-5"
                        isAlignAtEnd
                        isBlue
                      >
                        General links to external site
                      </Link>
                      <Link
                        rightIcon={light('chevron-right')}
                        onSelect={(selectedKey) =>
                          console.log(`selected ${selectedKey}`)
                        }
                        eventKey="test"
                        className="pt-5"
                        isAlignAtEnd
                        isBlue
                      >
                        General links to external site
                      </Link>
                      <Link
                        rightIcon={light('chevron-right')}
                        onSelect={(selectedKey) =>
                          console.log(`selected ${selectedKey}`)
                        }
                        eventKey="test"
                        className="pt-5"
                        isAlignAtEnd
                        isBlue
                      >
                        General links to external site
                      </Link>
                    </GenericCards>
                  </Container>
                </Col>
              </section>
              <section className="pt-10">
                <DefaultCard
                  variant="blue"
                  leftHeading="Ready to go?"
                  leftSubheading="Once you've had time to look over the information provided and are ready you can start your enrollment."
                  button={
                    <Button
                      variant="primary-shadow"
                      size="sm"
                      rightIcon={light('arrow-right')}
                      onClick={handleStepperVisible}
                    >
                      Get started
                    </Button>
                  }
                />
              </section>
            </>
          </>
        ) : (
          <SavingsEnrollmentStepper isVisible={handleRetirementCompletion} />
        )}
      </Container>
    </>
  );
};

export default SavingsEnrollment;
